import React from "react";
import { Result, Button, Typography, Alert } from "antd";
import _ from "lodash";
const { Paragraph, Text } = Typography;

const ErrorFallback = (props) => {
  const { title, cb, errorData, cbBtnName } = props;
  return (
    <div style={{ padding: "5px 20px" }}>
      <Result
        status="warning"
        title={title || "Something Went Wrong!"}
        subTitle="Please check the following information."
        extra={
          <Button type="primary" onClick={cb}>
            {cbBtnName}
          </Button>
        }
      />
      <Paragraph>
        <Text strong style={{ fontSize: 16 }}>
          Errors:
        </Text>
      </Paragraph>
      {typeof errorData !== "object" ? (
        <Alert showIcon type="warning" style={{ margin: "10px 0" }} message={errorData} />
      ) : (
        _.map(errorData || [], (value, key) =>
          typeof value !== "object" ? (
            <Alert
              showIcon
              type="warning"
              style={{ margin: "10px 0" }}
              key={key}
              message={`${key + 1}: ${value}`}
            />
          ) : (
            _.map(value, (_value, _key) => (
              <Alert
                showIcon
                type="warning"
                style={{ margin: "10px 0" }}
                key={_key}
                message={`${_key + 1}: ${_value}`}
              />
            ))
          )
        )
      )}
    </div>
  );
};

export default ErrorFallback;
